/** @jsx jsx */
import React, { useEffect, useMemo, useRef } from 'react'
import { jsx } from 'theme-ui'
import { FlexCol, FlexCols, VStack } from '../../../styles/els'
import Paragraph from '../../paragraph'
import Card from '../../card'
import VideoWrapper from '../../video-wrapper'
import { formatImage, resolveButtons } from '../../../lib/helpers'
import { ImageInline } from '../../image'

const TextIcons = (props) => {
  const { heading, text, icons } = props
  const base = icons && icons.length % 3 === 0 ? 3 : 4

  return (
    <VStack
      sx={{
        pt: 8,
      }}
    >
      {(heading || text) && (
        <div
          sx={{
            pb: icons && icons.length > 0 ? 4 : null,
          }}
        >
          <Paragraph
            heading={heading}
            htmlText={text}
            hTier={3}
            align="center"
          />
        </div>
      )}
      {icons && icons.length > 0 ? (
        <FlexCols>
          {icons &&
            icons.map((_icon, _i) => {
              const { image: _image, title } = _icon
              const image = formatImage(_image)

              return (
                <FlexCol
                  key={_i}
                  base={
                    base === 3
                      ? [1, null, null, 3]
                      : [1, null, 2, null, null, 4]
                  }
                >
                  <VStack>
                    {image && (
                      <div sx={{ width: '100%' }}>
                        <div sx={{ maxWidth: '320px', mx: 'auto' }}>
                          <ImageInline image={image} />
                        </div>
                      </div>
                    )}
                    {title && (
                      <h4 sx={{ textAlign: 'center', variant: 'text.bold_19' }}>
                        {title}
                      </h4>
                    )}
                  </VStack>
                </FlexCol>
              )
            })}
        </FlexCols>
      ) : null}
    </VStack>
  )
}

export default TextIcons
